"use client"
import { convertToLocale } from "@/lib/helpers/money"
import { HttpTypes } from "@medusajs/types"
import Image from "next/image"
import { useTranslate } from "@tolgee/react"

export const CartDropdownItem = ({
  item,
  currency_code,
}: {
  item: HttpTypes.StoreCartLineItem
  currency_code: string
}) => {
  const { t } = useTranslate()
  const original_total = convertToLocale({
    amount: (item.original_total || 0),
    currency_code,
  })

  const total = convertToLocale({
    amount: item.total,
    currency_code,
  })


  const compare_at_unit_price = convertToLocale({
    amount: item.compare_at_unit_price || 0,
    currency_code,
  })

  return (
    <div className="border rounded-sm p-1 flex gap-2 mb-4">
      <div className="w-[100px] h-[132px] flex items-center justify-center">
        {item.thumbnail ? (
          <Image
            src={decodeURIComponent(item.thumbnail)}
            alt={item.product_title || ""}
            width={80}
            height={90}
            className="w-[80px] h-[90px] object-cover rounded-xs"
            priority
          />
        ) : (
          <Image
            src={"/images/placeholder.svg"}
            alt={t("product.thumbnail_alt")}
            width={50}
            height={66}
            className="rounded-xs w-[50px] h-[66px] object-contain opacity-30"
          />
        )}
      </div>

      <div className="py-2">
        <h4 className="heading-xs">{item.product_title}</h4>
        <div className="label-md text-secondary">
          {item.variant?.options?.map(({ option, id, value }) => (
            <p key={id}>
              {option?.title}: <span className="text-primary">{value}</span>
            </p>
          ))}
          <p>
            {t("cart_dropdown_item.quantity")} <span className="text-primary">{item.quantity}</span>
          </p>
        </div>
        <div className="pt-2 flex items-center gap-2 mt-4 lg:mt-0">
          {(total !== original_total || item.compare_at_unit_price) && (
            <p className="line-through text-secondary label-md">
              {compare_at_unit_price || original_total}
            </p>
          )}
          <p className="label-lg">{total}</p>
        </div>
      </div>
    </div>
  )
}
